module.exports = __webpack_public_path__ + "static/img/woyaobangding_bg_logo@2x.c9b4faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woyaobangding_bg_logo@2x.png
// module id = rXCW
// module chunks = 34